"use client";

import type { CSSProperties } from "react";

import { cn } from "@/lib/utils";

export const MANUAL_FUNCTION_TOKEN_META = {
  R: { color: "#2A4DAB", groupLabel: "Thinkers" },
  C: { color: "#B8531F", groupLabel: "Connectors" },
  Ca: { color: "#0F4C3A", groupLabel: "Builders" },
  D: { color: "#5B3B1B", groupLabel: "Leaders" },
} as const;

export function parseManualCodeTokens(code: string): string[] {
  return code
    .split(" - ")
    .map((segment) => segment.trim())
    .filter(Boolean);
}

export function getLeadManualCodeToken(code: string): string | null {
  return parseManualCodeTokens(code)[0] ?? null;
}

export function ManualFunctionTokens({
  code,
  className,
  tokenClassName,
}: {
  code: string;
  className?: string;
  tokenClassName?: string;
}) {
  const tokens = parseManualCodeTokens(code);

  if (tokens.length === 0) {
    return null;
  }

  return (
    <span className={cn("manual-code-tokens", className)}>
      {tokens.map((tokenValue) => (
        <ManualCodeToken
          key={tokenValue}
          tokenValue={tokenValue}
          className={tokenClassName}
        />
      ))}
    </span>
  );
}

export function ManualCodeToken({
  tokenValue,
  className,
}: {
  tokenValue: string;
  className?: string;
}) {
  const tokenMeta =
    MANUAL_FUNCTION_TOKEN_META[
      tokenValue as keyof typeof MANUAL_FUNCTION_TOKEN_META
    ];

  return (
    <span
      className={cn("manual-code-token", className)}
      style={{ "--c": tokenMeta?.color ?? "#111111" } as CSSProperties}
    >
      {tokenValue}
    </span>
  );
}
